import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { Spinner } from "@fluentui/react-components";
import "./CSS/InitComponent.css";

import SideBarContainer from "../Containers/SideBarContainer/SideBarContainer";
import HeaderContainer from "../Containers/Header/HeaderContainer";
import LicencesContainer from "../Containers/Licences/LicencesContainer";
import ListMediaContainer from "../Containers/Medias/ListMediaContainer";
import AddMediaContainer from "../Containers/Medias/AddMediaContainer";
import HomeContainer from "../Containers/HomeContainer";
import ListAgentProfilesContainer from "../Containers/AgentProfiles/ListAgentProfilesContainer";
import ListAnalyticsProfilesContainer from "../Containers/Analytics/ListAnalyticsProfilesContainer";
import AnalyticsProfileContainer from "../Containers/Analytics/AnalyticsProfileContainer";
import ListCallFlowsContainer from "../Containers/CallFlows/ListCallFlowsContainer";
import CallFlowContainer from "../Containers/CallFlows/CallFlowContainer";
import CallFlowDiagramContainer from "../Containers/CallFlows/CallFlowDiagramContainer";
import AgentAIListContainer from "../Containers/AgentAI/AgentAIListContainer";
import AgentAIFormContainer from "../Containers/AgentAI/AgentAIFormContainer";
import SelectCallFlowContainer from "../Containers/AgentAI/SelectCallFlowContainer";
import ListChatFlowsContainer from "../Containers/ChatFlows/ListChatFlowsContainer";
import MailFlowsContainer from "../Containers/MailFlows/MailFlowsContainer";
import MailTemplatesContainer from "../Containers/MailFlows/MailTemplatesContainer";
import SmsTemplatesContainer from "../Containers/MailFlows/SmsTemplatesContainer";
import ChatFlowContainer from "../Containers/ChatFlows/ChatFlowContainer";
import ChatFlowDiagramContainer from "../Containers/ChatFlows/ChatFlowDiagramContainer";
import EntitiesContainer from "../Containers/Entities/EntitiesContainer";
import EntitieContainer from "../Containers/Entities/EntitieContainer";
import ListGroupsContainer from "../Containers/Groups/ListGroupsContainer";
import GroupContainer from "../Containers/Groups/GroupContainer";
import ListAgentsContainers from "../Containers/Agents/ListAgentsContainers";
import AgentsContainer from "../Containers/Agents/AgentsContainer";
import ListQueuesContainer from "../Containers/Queues/ListQueuesContainer";
import ListVariablesContainer from "../Containers/Variables/ListVariablesContainer";
import VariablesContainer from "../Containers/Variables/VariablesContainer";
import ListWorkflowsContainer from "../Containers/Workflows/ListWorkflowsContainer";
import WorkflowsContainer from "../Containers/Workflows/WorkflowsContainer";
import QueuesContainer from "../Containers/Queues/QueuesContainer";
import AgentsProfileContainer from "../Containers/AgentProfiles/AgentsProfileContainer";
///import Dashboard from "./Dashboard/Dashboard";
import AnalyticsDashboard from "./Dashboard/AnalyticsDashboard";
import RealtimeDashboardContainer from "../Containers/RealtimeDashboard/RealtimeDashboardContainer";
import ScopeListComponent from "./Dashboard/ScopeListComponent";
import { exampleDashboard } from "./Dashboard/exampleDashboard";
import GlobalSettingsContainer from "../Containers/GlobalSettings/GlobalSettingsContainer";

import {
  getAllLicences,
  getAllRoles,
  getAllMedia,
  GetAllAgent,
  GetAgent,
  GetAllCallFlow,
  GetAllAgentAI,
  GetAllAgentProfile,
  getAllQueue,
  GetAllChatFlow,
  getAllPermissions,
  checkConsentStatusApi,
  getAllGroups,
  getPartnerTenants,
  getAllVariables,
  getAllWorkflows,
  GetAllAnalyticsProfiles,
} from "../Services/HeedifyServices";

import { getAccessToken } from "../Services/GraphServices";
import { AbilityProvider } from "../Contexts/AbilityContext";
import {
  defineAbilityFromPermissions,
  generateConsolidatedPermissions,
} from "../Utils/AbilityUtils";
import RecordingContainer from "../Containers/RecordingsManagement/RecordingContainer";
import ProtectedRoute from "./ProtectedRoute";

const InitComponent = (props) => {
  const authContext = useMsal();
  let accounts = authContext.accounts;
  let instance = authContext.instance;
  const activeAccount = accounts[0];
  let userId = null;
  let tenantId = null;
  if (accounts[0]) {
    userId = accounts[0].localAccountId;
    tenantId = accounts[0].tenantId;
  }

  const [ability, setAbility] = useState(null);
  const [accessToken, setAccessToken] = useState(null);

  // Feature flag par tenant : agent IA gated par features.iaAgent sur l'objet tenant.
  // Sert à protéger les routes /iaagent (pas seulement masquer le menu).
  const partnerTenants = useSelector((s) => s.reducer.partnerTenants);
  // partnerTenants se charge en async non bloquant : on ne bloque l'accès QUE
  // lorsque les tenants sont chargés ET que le flag est explicitement absent/false
  // (sinon un tenant autorisé serait redirigé à tort au refresh direct sur /iaagent).
  const tenantsLoaded = Array.isArray(partnerTenants) && partnerTenants.length > 0;
  const activeTenant = tenantsLoaded
    ? partnerTenants.find((t) => t.tenantId === props.ACTIVE_TENANT)
    : null;
  const iaAgentBlocked = tenantsLoaded && !activeTenant?.features?.iaAgent;

  /**
   * Maintient à jour le token porté par l'état React (`token={accessToken}` en prop).
   *
   * ⚠️ Ce n'est PAS ce qui garantit la fraîcheur des appels : la garantie est à l'instant de la
   * requête, dans l'intercepteur axios de `Services/authToken.js`. Une minuterie ne peut pas
   * suffire — entre deux tics, ou après une mise en veille de la machine, la requête partirait
   * quand même avec un token mort.
   *
   * Ce rafraîchissement ne sert donc qu'à éviter que l'état React ne traîne un token visiblement
   * périmé. Un échec ne remplace PAS le token en place (getAccessToken résout `undefined`) :
   * mieux vaut un token bientôt périmé qu'aucun token — c'est ce dernier cas qui produisait des
   * requêtes sans en-tête Authorization.
   */
  useEffect(() => {
    if (!instance || !activeAccount) return;

    let cancelled = false;
    const refreshToken = async () => {
      const fresh = await getAccessToken(instance, activeAccount);
      if (!cancelled && fresh) setAccessToken(fresh);
    };

    const intervalId = setInterval(refreshToken, 5 * 60 * 1000);
    window.addEventListener('focus', refreshToken);
    return () => {
      cancelled = true;
      clearInterval(intervalId);
      window.removeEventListener('focus', refreshToken);
    };
  }, [instance, activeAccount]);

  useEffect(() => {
    if (!instance || !activeAccount) return;

    (async () => {
      try {
        // Restaurer le tenant actif depuis sessionStorage ou utiliser celui du compte
        const savedTenantId = sessionStorage.getItem('activeTenantId');
        const activeTenantToUse = savedTenantId || tenantId;
        
        if (activeTenantToUse) {
          props.setActiveTenant(activeTenantToUse);
        }

        const token = await getAccessToken(instance, activeAccount);
       
        setAccessToken(token);
        // Utiliser le tenant actif pour récupérer les permissions
        const data = await getAllPermissions(activeTenantToUse, token);
        const { scopes, roles } = data;
        props.setScopes(scopes);
        props.setRoles(roles);
        props.setScopesNames(Object.keys(scopes));

        // Onboarding : aucun droit ET tenant non consenti (CheckAppConsent → 400 IsAdmin:false)
        // ⇒ bootstrapMode = true (tenant neuf, il faut proposer le 1er consent).
        // Le && court-circuite : checkConsentStatusApi n'est appelé que si scopes vides.
        // Un user non-admin d'un tenant déjà consenti (IsAdmin:true) reste à false.
        // Jamais de bootstrap en accès partenaire : cf. le second appel plus bas.
        props.setBootstrapMode(
          !data.partnerAccess &&
          (!scopes || Object.keys(scopes).length === 0) &&
          ((await checkConsentStatusApi(activeTenantToUse, data.userId, token))?.IsAdmin === false)
        );

        // Fusion et définition des droits CASL
        const consolidated = generateConsolidatedPermissions(roles, scopes);
        props.setPermissions(consolidated);
        const caslAbility = defineAbilityFromPermissions(consolidated);
        setAbility(caslAbility);

        // Chargement des autres données IMMÉDIATEMENT.
        // Important : on n'attend PAS getPartnerTenants ici. Cet appel ne sert qu'au
        // sélecteur de tenant + à la validation sessionStorage ; s'il est lent ou
        // bloqué (ex. timeout backend), un `await` ici gèlerait tout le portail ~60s
        // (rôles, queues, callflows, entités…). On le lance donc en arrière-plan.
        fetchData(token, scopes);

        // Partner tenants en arrière-plan (non bloquant) : alimente le sélecteur de tenant.
        getPartnerTenants(tenantId, token)
          .then((partnerTenantsData) => {
            const { myTenant, tenants } = partnerTenantsData || {};
            const currentTenant = myTenant || {
              customerName: "Mon compte",
              tenantId: tenantId,
            };
            const allTenants = [currentTenant, ...(tenants || [])];
            props.setPartnerTenants(allTenants);

            // Vérifier si le tenant restauré est valide
            const validTenantIds = allTenants.map((t) => t.tenantId);
            if (activeTenantToUse !== tenantId && !validTenantIds.includes(activeTenantToUse)) {
              console.warn("⚠️ Tenant invalide dans sessionStorage, utilisation du tenant du compte");
              sessionStorage.removeItem("activeTenantId");
              props.setActiveTenant(tenantId);
            }
          })
          .catch((error) => {
            console.error("⚠️ getPartnerTenants (non bloquant) a échoué :", error);
            props.setPartnerTenants([{ customerName: "Mon compte", tenantId: tenantId }]);
          });
      } catch (error) {
        console.error("❌ Erreur d'initialisation :", error);
      }
    })();
  }, [instance, activeAccount]);

  // Recharger les données quand le tenant actif change
  useEffect(() => {
    if (!props.ACTIVE_TENANT || !instance || !activeAccount) return;

    // Éviter le double chargement initial uniquement au premier render
    if (props.ACTIVE_TENANT === tenantId && !ability) return;

    // ⚠️ VIDER AVANT DE RECHARGER — les listes appartiennent à l'ANCIEN tenant.
    //
    // Le rechargement est asynchrone : entre le basculement du sélecteur et l'arrivée des
    // nouvelles données, le tableau continuait d'afficher les lignes du tenant précédent. Un clic
    // pendant cette fenêtre emmène un identifiant ÉTRANGER dans l'écran de détail, qui va le
    // chercher dans le nouveau tenant, ne le trouve pas, et rend un formulaire vide — constaté
    // le 17/08/2026 : /queues/queue1779183915830 ouvert sous AcmeLab, alors que cette file
    // appartient au tenant Heedify.
    //
    // On ne peut pas se contenter de « recharger plus vite » : la fenêtre existera toujours.
    // Une liste vide pendant une seconde est lisible ; une liste fausse ne l'est pas.
    // On remet exactement l'état INITIAL du store (`null`), pas des tableaux vides : c'est l'état
    // que l'application sait déjà rendre au démarrage, donc aucun composant ne peut s'y casser.
    // Un `[]` dirait « ce tenant n'a pas de files » avant même d'avoir demandé.
    props.setQueues(null);
    props.setGroups(null);
    props.setCallFlows(null);
    props.setChatFlows(null);
    props.setWhatsAppFlows(null);
    props.setAgents(null);
    props.setAgentAIs(null);
    props.setMedias(null);
    props.setLicences(null);
    props.setAgentProfiles(null);
    props.setAnalyticsProfiles(null);

    (async () => {
      try {
        const token = await getAccessToken(instance, activeAccount);
        
        // Utiliser le tenant actif pour récupérer les permissions
        const data = await getAllPermissions(props.ACTIVE_TENANT, token);
        const { scopes, roles } = data;

        props.setScopes(scopes);
        props.setRoles(roles);
        props.setScopesNames(Object.keys(scopes));

        // Onboarding (cf. chargement initial) : aucun droit + tenant non consenti ⇒ bootstrapMode.
        // ⚠️ JAMAIS DE BOOTSTRAP EN ACCÈS PARTENAIRE.
        //
        // `bootstrapMode` déverrouille les boutons de consentement (GlobalSettingsComponent :
        // `canConsent = canUpdate || bootstrapMode`). Il existe pour le PREMIER administrateur
        // d'un tenant vierge, sans qui rien ne peut démarrer — il faut être admin pour consentir,
        // et consentir pour devenir admin.
        //
        // Un revendeur qui ouvre un client SANS AUCUNE ENTITÉ reçoit des scopes vides et héritait
        // donc de ce contournement. Or l'URL de consentement pointe sur /common
        // (HeedifyServices.getAdminConsentUrl) : Microsoft résout le tenant sur le COMPTE
        // CONNECTÉ. Le clic n'aurait pas échoué — il aurait accordé le consentement dans
        // l'annuaire Entra DU REVENDEUR, silencieusement. Le verrou serveur n'a aucune prise
        // là-dessus : il ne protège que l'enregistrement en base.
        props.setBootstrapMode(
          !data.partnerAccess &&
          (!scopes || Object.keys(scopes).length === 0) &&
          ((await checkConsentStatusApi(props.ACTIVE_TENANT, data.userId, token))?.IsAdmin === false)
        );

        // Régénérer les abilities CASL avec les nouvelles permissions
        const consolidated = generateConsolidatedPermissions(roles, scopes);
        props.setPermissions(consolidated);
        const caslAbility = defineAbilityFromPermissions(consolidated);
        setAbility(caslAbility);

        // Recharger les données avec le nouveau tenant
        fetchData(token, scopes);
      } catch (error) {
        console.error("❌ Erreur lors du rechargement des données:", error);
      }
    })();
  }, [props.ACTIVE_TENANT]);

  const fetchData = (token, scopes) => {
    if (!token || !scopes) return;

    const scopeNames = Object.keys(scopes || {});
    if (scopeNames.length === 0) return;

    // Utiliser props.ACTIVE_TENANT au lieu de tenantId
    const currentTenantId = props.ACTIVE_TENANT || tenantId;

    Promise.all([
      getAllRoles(currentTenantId, token),
      GetAllAgentProfile(currentTenantId, token),
      getAllMedia(currentTenantId, token),
      GetAllAnalyticsProfiles(currentTenantId, token),
    ])
      .then(([roles, profiles, medias, analyticsProfiles]) => {
        props.setAllRoles(roles);
        props.setAgentProfiles(profiles.data);

        // Set Analytics Profiles in Redux
        if (analyticsProfiles.success && analyticsProfiles.data) {
          const analyticsProfilesObj = {};
          analyticsProfiles.data.forEach(p => {
            analyticsProfilesObj[p.id] = p;
          });
          props.setAnalyticsProfiles(analyticsProfilesObj);
        }

        // Ajouter scope "default" à chaque média
        const mediasWithScope = medias.map(media => ({
          ...media,
          scope: "default"
        }));
        props.setMedias(mediasWithScope);
        
      })
      .catch(console.error);

    const licencesPromises = scopeNames.map((s) =>
      getAllLicences(currentTenantId, token, s, token)
    );

    const agentsPromises = scopeNames.map((s) =>
      GetAllAgent(currentTenantId, userId, s, token)
    );
    const callFlowPromises = scopeNames.map((s) =>
      GetAllCallFlow(currentTenantId, userId, s, token)
    );
    // Agents IA (type iaAgent du container Flows) — considérés comme des flows
    // côté CDR/recording (FLOW_ID = id de l'agent IA). Chargés ici pour être
    // sélectionnables dans le filtre Flows analytics + le scope recordings.
    const iaAgentPromises = scopeNames.map((s) =>
      GetAllAgentAI(currentTenantId, userId, s, token)
    );
    const groupsPromises = scopeNames.map((s) =>
      getAllGroups(currentTenantId, s, userId, token)
    );
    const chatFlowPromises = scopeNames.map((s) =>
      GetAllChatFlow(currentTenantId, userId, s, token)
    );
    const queuesPromises = scopeNames.map((s) =>
      getAllQueue(currentTenantId, userId, s, token)
    );

    const variablesPromises = scopeNames.map((s) =>
      getAllVariables(currentTenantId, s, token)
    );

    const workflowsPromises = scopeNames.map((s) =>
      getAllWorkflows(currentTenantId, s, token)
    );

    Promise.all(licencesPromises).then((results) => {
      // Formater les licences par scope
      const licencesByScope = {};
      results.forEach((result) => {
        if (result && result.RowKey) {
          licencesByScope[result.RowKey] = result;
        }
      });
      props.setLicences(results);
      props.setAvailableLicences(licencesByScope);
    });
    
    Promise.all(agentsPromises).then((data) => props.setAgents(data.flat()));

    // Agents IA : agréger par scope + dédupliquer par id
    Promise.all(iaAgentPromises).then((results) => {
      const byId = {};
      results.forEach((res) => {
        const arr = Array.isArray(res) ? res : (res ? Object.values(res) : []);
        arr.forEach((a) => { if (a && a.id) byId[a.id] = a; });
      });
      props.setAgentAIs(Object.values(byId));
    });
    Promise.all(chatFlowPromises).then((data) => {
      // Filtrer les objets vides et concaténer tous les flows
      const allChatFlows = data.flat().filter(item => item && Object.keys(item).length > 0);
      
      // Séparer les flows WhatsApp (ceux qui ont whatsAppId et teamsBotId)
      const whatsAppFlows = allChatFlows.filter(flow => 
        flow.whatsAppId && flow.teamsBotId
      );
      
      // Les chatflows normaux (sans whatsAppId et teamsBotId)
      const regularChatFlows = allChatFlows.filter(flow => 
        !flow.whatsAppId || !flow.teamsBotId
      );
      
      props.setChatFlows(regularChatFlows);
      props.setWhatsAppFlows(whatsAppFlows);
    });
   Promise.all(queuesPromises).then((data) => {
  const mergedQueues = data
    .filter(item => item && typeof item === "object" && !Array.isArray(item) && Object.keys(item).length > 0)
    .reduce((acc, curr) => ({ ...acc, ...curr }), {});

      props.setQueues(mergedQueues);
    });

    // Handle groups and supervised agents
    Promise.all(groupsPromises).then((data) => {
      const groups = data.flat();
      props.setGroups(groups);

      // Extract supervised agent IDs from groups
      const supervisedAgentIds = [];
      groups.forEach((group) => {
        if (group.agentsIds?.includes(userId)) {
          const agentDetails = group.agentDetails || {};
          // Sans la condition isSupervisor: si l'utilisateur est dans le groupe,
          // tous les agents du groupe sont considérés comme supervisés
          Object.keys(agentDetails).forEach((agentId) => {
            if (!supervisedAgentIds.includes(agentId)) {
              supervisedAgentIds.push(agentId);
            }
          });
        }
      });

      // Fetch agent profiles for supervised agents
      if (supervisedAgentIds.length > 0) {
        // Pour le check d'auth backend : passer un scope où l'user est admin (le 1er
        // de ses scopes). L'agent réel peut être dans un autre scope, le backend récupère
        // par agentId — le scope de l'URL sert juste pour vérifier l'autorisation.
        const authScope = scopeNames[0] || "default";
        const agentProfilesPromises = supervisedAgentIds.map((agentId) =>
          GetAgent(currentTenantId, userId, agentId, token, authScope)
            .then((agentProfile) => ({ agentId, agentProfile }))
            .catch((error) => {
              console.error(`Error fetching profile for agent ${agentId}:`, error);
              return { agentId, agentProfile: null };
            })
        );

        Promise.all(agentProfilesPromises).then((results) => {
          const agentsProfiles = {};
          const validSupervisedAgentIds = [];

          results.forEach(({ agentId, agentProfile }) => {
            if (agentProfile && Object.keys(agentProfile).length > 0) {
              agentsProfiles[agentId] = agentProfile;
              validSupervisedAgentIds.push(agentId);
            }
          });

          props.setSupervisedAgentDetails(agentsProfiles);
          props.setSupervisedAgentIds(validSupervisedAgentIds);
        });
      }
    });

    // Handle call flows and extract IDs for recording access
    Promise.all(callFlowPromises).then((data) => {
      // ⚠️ Fusion par ID, surtout PAS `Object.assign({}, ...data)`.
      //
      // `data` est un tableau de TABLEAUX (un par scope) : `CallFlowManagement/get/ALL`
      // renvoie le `resources` de Cosmos. Or Object.assign fusionne un tableau par ses
      // CLÉS D'INDEX — le 2ᵉ scope écrase les indices 0..n du 1ᵉʳ, le 3ᵉ écrase à nouveau,
      // etc. On ne garde donc que max(longueurs) entrées au lieu de la somme, avec des
      // doublons ; la liste dédoublonne ensuite par id et le total s'effondre.
      //
      // Le scope "default" étant celui qui renvoie le PLUS de flows (côté Provisioning,
      // la branche `scope === "default"` ne filtre pas sur c.scope et retourne tous les
      // flows du tenant), c'est justement lui qui se faisait écraser par les scopes
      // suivants, plus petits. Exemple réel : default=10, Marseille=2, Lyon=3 → 7 flows
      // affichés, et les 3 premiers du tenant purement invisibles.
      const flowsById = new Map();
      data.forEach((scopeFlows) => {
        const arr = Array.isArray(scopeFlows)
          ? scopeFlows
          : (scopeFlows && typeof scopeFlows === 'object' ? Object.values(scopeFlows) : []);
        arr.forEach((flow) => { if (flow && flow.id) flowsById.set(flow.id, flow); });
      });
      const flattened = Array.from(flowsById.values());
      props.setCallFlows(flattened);
      // Extract call flow IDs where user has recording access
      const callFlowsIds = flattened
        .filter((callflow) =>
          callflow.callRecordingReadersDetails &&
          Object.keys(callflow.callRecordingReadersDetails).includes(userId)
        )
        .map((callflow) => callflow.id);

      props.setCallFlowsIds(callFlowsIds);
    });

    Promise.all(variablesPromises).then((data) => props.setVariables(data.flat()));
   
    Promise.all(workflowsPromises).then((data) => {
      const allWorkflows = data.flat();
      props.setWorkflows(allWorkflows);
    });
  };

  if (!ability)
    return (
      <div className="init-loading-container">
     
          <Spinner size="extra-large"  />
        </div>
   
    );
  return (
    <AbilityProvider ability={ability}>
      <div className="init-container">
        <HeaderContainer />
        <Router>
          <div className="init-main-layout">
            <SideBarContainer />
            <Routes>
              <Route path="/" element={<div className="init-route-container"><HomeContainer /></div>} />
              <Route
                path="/analytics"
                element={
                  <ProtectedRoute module="Analytics">
                    <div className="init-route-container">
                      <ScopeListComponent token={accessToken} />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/realtime-dashboard"
                element={
                  <ProtectedRoute module="realTimeDashboard">
                    <div className="init-route-container">
                      <RealtimeDashboardContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/analytics/:scope"
                element={
                  <ProtectedRoute module="Analytics">
                    <div className="init-route-container">
                      <AnalyticsDashboard
                        tenantId={tenantId}
                        token={accessToken}
                      />
                    </div>
                  </ProtectedRoute>
                }
              />
           
              <Route path="/recording" element={
                <ProtectedRoute module="Recordings">
                  <div className="init-route-container">
                    <RecordingContainer />
                  </div>
                </ProtectedRoute>
              } />
             
              <Route path="/globalSettings" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
              {/* Consent Callback Routes */}
              <Route path="/ConsentReports" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/Consentpresence" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/Consentcc" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/ConsentAgentConsole" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/ConsentAgentConsoleUnify" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/ConsentCCUnify" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
             
              <Route path="/queues" element={
                <ProtectedRoute module="Queue">
                  <div className="init-route-container">
                    <ListQueuesContainer />
                  </div>
                </ProtectedRoute>
              } />
              {/* `:scopeParam?` — le scope voyageait dans `location.state`, perdu au moindre
                  rechargement de page : on retombait alors sur "default". Dans l'URL, le lien
                  est rechargeable et partageable. Optionnel pour ne pas casser les liens déjà
                  émis, `location.state` restant le repli. */}
              <Route path="/queues/:queueId/:scopeParam?" element={
                <ProtectedRoute module="Queue">
                  <div className="init-route-container">
                    <QueuesContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/callFlows" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <ListCallFlowsContainer />
                  </div>
                </ProtectedRoute>
              } />
              {/* Routes agent IA gatées par le flag tenant features.iaAgent :
                  si désactivé, on redirige vers l'accueil (bloque aussi l'accès URL direct). */}
              <Route path="/iaagent" element={
                iaAgentBlocked ? <Navigate to="/" replace /> : (
                  <ProtectedRoute module="Flow">
                    <div className="init-route-container">
                      <AgentAIListContainer />
                    </div>
                  </ProtectedRoute>
                )
              } />
              <Route path="/iaagent/select-callflow" element={
                iaAgentBlocked ? <Navigate to="/" replace /> : (
                  <ProtectedRoute module="Flow">
                    <div className="init-route-container">
                      <SelectCallFlowContainer />
                    </div>
                  </ProtectedRoute>
                )
              } />
              <Route
                path="/iaagent/:agentAIId"
                element={
                  iaAgentBlocked ? <Navigate to="/" replace /> : (
                    <ProtectedRoute module="Flow">
                      <div className="init-route-container">
                        <AgentAIFormContainer />
                      </div>
                    </ProtectedRoute>
                  )
                }
              />
              <Route
                path="/callFlows/:callFlowId"
                element={
                  <ProtectedRoute module="Flow">
                    <div className="init-route-container">
                      <CallFlowContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/callFlows/diagram/:callFlowId"
                element={
                  <ProtectedRoute module="Flow">
                    <div className="init-route-diagram-container">
                      <CallFlowDiagramContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="/chatFlows" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <ListChatFlowsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route
                path="/chatFlows/:chatFlowId"
                element={
                  <ProtectedRoute module="Flow">
                    <div className="init-route-container">
                      <ChatFlowContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/chatFlows/diagram/:chatFlowId"
                element={
                  <ProtectedRoute module="Flow">
                    <div className="init-route-diagram-container">
                      <ChatFlowDiagramContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              {/* Flux mail — même module de permission que les autres flux : un flux mail est
                  un plan de routage au même titre qu'un CallFlow, et l'administrateur qui a le
                  droit d'en configurer un a celui de configurer l'autre. Le serveur revérifie
                  de toute façon que l'appelant est administrateur DU SCOPE demandé. */}
              <Route path="/mailFlows" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <MailFlowsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/mailTemplates" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <MailTemplatesContainer />
                  </div>
                </ProtectedRoute>
              } />
              {/* Quick SMS — les messages qu'un agent envoie pendant un appel. Même module de
                  permission que les autres gabarits : le serveur revérifie de toute façon que
                  l'appelant est administrateur DU SCOPE demandé. */}
              <Route path="/smsTemplates" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <SmsTemplatesContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/whatsapp" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <ListChatFlowsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route
                path="/whatsapp/:chatFlowId"
                element={
                  <ProtectedRoute module="Flow">
                    <div className="init-route-container">
                      <ChatFlowContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/whatsapp/diagram/:chatFlowId"
                element={
                  <ProtectedRoute module="Flow">
                    <div className="init-route-diagram-container">
                      <ChatFlowDiagramContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="/groups" element={
                <ProtectedRoute module="Group">
                  <div className="init-route-container">
                    <ListGroupsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route
                path="/groups/:groupId/:scopeParam"
                element={
                  <ProtectedRoute module="Group">
                    <div className="init-route-container">
                      <GroupContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="/entities" element={
                <ProtectedRoute module="Entity">
                  <div className="init-route-container">
                    <EntitiesContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route
                path="/entities/:entityName"
                element={
                  <ProtectedRoute module="Entity">
                    <div className="init-route-container">
                      <EntitieContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="/agents" element={
                <ProtectedRoute module="Agent">
                  <div className="init-route-container">
                    <ListAgentsContainers />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/agents/:agentId" element={
                <ProtectedRoute module="Agent">
                  <div className="init-route-container">
                    <AgentsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route
                path="/agentsProfiles"
                element={
                  <ProtectedRoute module="Agent">
                    <div className="init-route-container">
                      <ListAgentProfilesContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/agentsProfiles/:profileId"
                element={
                  <ProtectedRoute module="Agent">
                    <div className="init-route-container">
                      <AgentsProfileContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/analyticsProfile"
                element={
                  <ProtectedRoute module="Analytics">
                    <div className="init-route-container">
                      <ListAnalyticsProfilesContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/analyticsProfile/:profileId"
                element={
                  <ProtectedRoute module="Analytics">
                    <div className="init-route-container">
                      <AnalyticsProfileContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="/medias" element={
                <ProtectedRoute module="Media">
                  <div className="init-route-container">
                    <ListMediaContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/medias/addMedia" element={
                <ProtectedRoute module="Media">
                  <div className="init-route-container">
                    <AddMediaContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/licences" element={
                <ProtectedRoute module="Licences">
                  <div className="init-route-container">
                    <LicencesContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/variables" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <ListVariablesContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/variables/:variableId" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <VariablesContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/workflows" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <ListWorkflowsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/workflows/:workflowId" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <WorkflowsContainer />
                  </div>
                </ProtectedRoute>
              } />
            </Routes>
          </div>
        </Router>
      </div>
    </AbilityProvider>
  );
};

export default InitComponent;
